// extracted by mini-css-extract-plugin
module.exports = {"container":"attitude-chart_container_1gTlc","noDataBox":"attitude-chart_noDataBox_19Uzw","icon":"attitude-chart_icon_nR-p5","chartBox":"attitude-chart_chartBox_1AkiT"};